let Search = function() {
    let input = document.querySelector('.search');
    let result = document.querySelectorAll('.td');
    let wrapper = document.querySelectorAll('.wrapper');
    let mainBlock = document.querySelector('.main-block');
    let eventlink = document.querySelector('.eventlink');

    input.oninput = handleChange;

    function handleChange(e) {
        if (e.target.value.toLowerCase() == 'мозгобитва'
            || e.target.value.toLowerCase() == 'м'
            || e.target.value.toLowerCase() == 'ма'
            || e.target.value.toLowerCase() == 'мас'
            || e.target.value.toLowerCase() == 'масл'
            || e.target.value.toLowerCase() == 'масле'
            || e.target.value.toLowerCase() == 'маслен'
            || e.target.value.toLowerCase() == 'маслени'
            || e.target.value.toLowerCase() == 'маслениц'
            || e.target.value.toLowerCase() == 'масленица') {
            result[0].classList.add('hide');
        } else result[0].classList.remove('hide');

        if (e.target.value.toLowerCase() == 'встреча'
            || e.target.value.toLowerCase() == 'в'
            || e.target.value.toLowerCase() == 'вс'
            || e.target.value.toLowerCase() == 'вст'
            || e.target.value.toLowerCase() == 'встр'
            || e.target.value.toLowerCase() == 'встре'
            || e.target.value.toLowerCase() == 'встреч'
            || e.target.value.toLowerCase() == 'встреча я'
            || e.target.value.toLowerCase() == 'встреча яз'
            || e.target.value.toLowerCase() == 'встреча языкового') {
            result[1].classList.add('hide');
        } else result[1].classList.remove('hide');

        if (e.target.value.toLowerCase() == 'запуск'
            || e.target.value.toLowerCase() == 'з'
            || e.target.value.toLowerCase() == 'за'
            || e.target.value.toLowerCase() == 'зап'
            || e.target.value.toLowerCase() == 'запу'
            || e.target.value.toLowerCase() == 'запус'
            || e.target.value.toLowerCase() == 'запуск с'
            || e.target.value.toLowerCase() == 'запуск сай'
            || e.target.value.toLowerCase() == 'запуск сайт'
            || e.target.value.toLowerCase() == 'запуск сайта'
            || e.target.value.toLowerCase() == 'запуск сайта у'
            || e.target.value.toLowerCase() == 'запуск сайта ур'
            || e.target.value.toLowerCase() == 'запуск сайта урф'
            || e.target.value.toLowerCase() == 'запуск сайта урфу'
            || e.target.value.toLowerCase() == 'сайт'
            || e.target.value.toLowerCase() == 'урфу'
            || e.target.value.toLowerCase() == 'у'
            || e.target.value.toLowerCase() == 'ур'
            || e.target.value.toLowerCase() == 'урф'
            || e.target.value.toLowerCase() == 'с'
            || e.target.value.toLowerCase() == 'са'
            || e.target.value.toLowerCase() == 'сай'
            || e.target.value.toLowerCase() == 'сайт') {
            result[2].classList.add('hide');
        } else result[2].classList.remove('hide');

        if (e.target.value.toLowerCase() == 'киновечер'
            || e.target.value.toLowerCase() == 'к'
            || e.target.value.toLowerCase() == 'ки'
            || e.target.value.toLowerCase() == 'кин'
            || e.target.value.toLowerCase() == 'кино'
            || e.target.value.toLowerCase() == 'вечер'
            || e.target.value.toLowerCase() == 'в'
            || e.target.value.toLowerCase() == 'ве'
            || e.target.value.toLowerCase() == 'веч'
            || e.target.value.toLowerCase() == 'вечер'
            || e.target.value.toLowerCase() == 'кино вечер'
            || e.target.value.toLowerCase() == 'кино в'
            || e.target.value.toLowerCase() == 'кино ве'
            || e.target.value.toLowerCase() == 'кино веч'
            || e.target.value.toLowerCase() == 'кино вече') {
            result[3].classList.add('hide');
        } else result[3].classList.remove('hide');

        if (e.target.value.toLowerCase() == 'вечер интеллектуальных игр'
            || e.target.value.toLowerCase() == 'вечер'
            || e.target.value.toLowerCase() == 'игр'
            || e.target.value.toLowerCase() == 'интеллектуальных'
            || e.target.value.toLowerCase() == 'в'
            || e.target.value.toLowerCase() == 'ве'
            || e.target.value.toLowerCase() == 'веч'
            || e.target.value.toLowerCase() == 'вече'
            || e.target.value.toLowerCase() == 'и'
            || e.target.value.toLowerCase() == 'ин'
            || e.target.value.toLowerCase() == 'инт'
            || e.target.value.toLowerCase() == 'инте'
            || e.target.value.toLowerCase() == 'интел'
            || e.target.value.toLowerCase() == 'интеллект'
            || e.target.value.toLowerCase() == 'и'
            || e.target.value.toLowerCase() == 'иг'
            || e.target.value.toLowerCase() == 'игр') {
            result[4].classList.add('hide');
        } else result[4].classList.remove('hide');

        if (e.target.value.toLowerCase() == 'фотомарафон'
            || e.target.value.toLowerCase() == 'фото марафон'
            || e.target.value.toLowerCase() == 'фото'
            || e.target.value.toLowerCase() == 'фо'
            || e.target.value.toLowerCase() == 'марафон'
            || e.target.value.toLowerCase() == 'фот'
            || e.target.value.toLowerCase() == 'м'
            || e.target.value.toLowerCase() == 'ма'
            || e.target.value.toLowerCase() == 'мар'
            || e.target.value.toLowerCase() == 'мара'
            || e.target.value.toLowerCase() == 'мараф'
            || e.target.value.toLowerCase() == 'марафо'
            || e.target.value.toLowerCase() == 'ф') {
            result[5].classList.add('hide');
        } else result[5].classList.remove('hide');



        input.onclick = function Hide() {
            if (!result[0].classList.contains('hide') || !result[1].classList.contains('hide') || !result[2].classList.contains('hide')) {
                result[0].classList.remove('hide');
                result[1].classList.remove('hide');
                result[2].classList.remove('hide');
            }
        }

        eventlink.onclick = function Hiding() {
            if (!result[0].classList.contains('hide') || !result[1].classList.contains('hide') || !result[2].classList.contains('hide')) {
                result[0].classList.remove('hide');
                result[1].classList.remove('hide');
                result[2].classList.remove('hide');
            }
        }

        wrapper[1].onclick = function Hiding() {
            if (!result[0].classList.contains('hide') || !result[1].classList.contains('hide') || !result[2].classList.contains('hide')) {
                result[0].classList.remove('hide');
                result[1].classList.remove('hide');
                result[2].classList.remove('hide');
            }
        }

        wrapper[2].onclick = function Hiding() {
            if (!result[0].classList.contains('hide') || !result[1].classList.contains('hide') || !result[2].classList.contains('hide')) {
                result[0].classList.remove('hide');
                result[1].classList.remove('hide');
                result[2].classList.remove('hide');
            }
        }

        mainBlock.onclick = function Hiding() {
            if (!result[0].classList.contains('hide') || !result[1].classList.contains('hide') || !result[2].classList.contains('hide')) {
                result[0].classList.remove('hide');
                result[1].classList.remove('hide');
                result[2].classList.remove('hide');
            }
        }


    }
}

export default Search;